<template>
  <v-select
    v-bind="$attrs"
    class="theme-input"
    :value="value"
    :items="items"
    :item-text="itemText"
    :item-value="itemValue"
    :loading="loading"
    :disabled="disabled"
    :clearable="clearable"
    :multiple="multiple"
    :chips="chips"
    :menu-props="{
      contentClass: 'theme-select-menu',
      transition: 'slide-y-transition',
      offsetY: true,
      maxHeight: 300,
    }"
    v-on="$listeners"
  />
</template>

<script>
export default {
  name: "ThemedSelector",
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number, Object, Array],
      default: null,
    },
    items: {
      type: Array,
      required: true,
    },
    itemText: {
      type: [String, Function],
      default: "text",
    },
    itemValue: {
      type: String,
      default: "value",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    chips: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.theme-input::v-deep .v-input__slot {
  backdrop-filter: blur(10px);
  border: 1px solid var(--color-border) !important;
  border-radius: var(--radius-md) !important;
  transition: var(--transition-default);
  padding: 12px 16px;
  background-color: var(--color-surface-light) !important;
}

.theme-input::v-deep .v-input__slot:hover {
  background-color: var(--color-surface-light) !important;
  border-color: var(--color-secondary-light) !important;
  border: 1px solid var(--color-secondary-light) !important;
}

.theme-input::v-deep .v-input--is-focused .v-input__slot {
  background-color: var(--color-surface) !important;
  border-color: var(--color-secondary) !important;
}

.theme-input::v-deep .v-label {
  color: var(--color-text-muted) !important;
  font-weight: 500;
  font-size: 14px;
}

.theme-input::v-deep .v-select__selections {
  color: var(--color-text) !important;
  font-weight: 500;
  font-size: 14px;
}

.theme-input::v-deep .v-select__selection {
  color: var(--color-text) !important;
}

.theme-input::v-deep .v-input__append-inner {
  margin-top: 0 !important;
  align-self: center;
}

.theme-input::v-deep .v-input__append-inner .v-icon {
  color: var(--color-text) !important;
  transition: var(--transition-default);
}

.theme-input::v-deep .v-input__append-inner .v-icon:hover {
  color: var(--color-secondary-light) !important;
}

.theme-input::v-deep .v-chip {
  background-color: var(--color-secondary-light) !important;
  color: var(--color-text) !important;
}

.theme-input::v-deep .v-chip__close {
  color: var(--color-text) !important;
}

/* Dropdown menu styling */
.theme-select-menu {
  background-color: var(--color-surface) !important;
  border: 1px solid var(--color-border) !important;
  border-radius: var(--radius-md) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.theme-select-menu .v-list-item {
  color: var(--color-text) !important;
  min-height: 40px !important;
  padding: 8px 16px !important;
}

.theme-select-menu .v-list-item:hover {
  background-color: var(--color-secondary-light) !important;
}

.theme-select-menu .v-list-item--active {
  background-color: var(--color-secondary) !important;
  color: var(--color-text) !important;
}

.theme-select-menu .v-list-item--disabled {
  color: var(--color-text-muted) !important;
  opacity: 0.6;
}

/* Error state styling */
.theme-input::v-deep .v-input--error .v-input__slot {
  border-color: var(--color-error) !important;
}

.theme-input::v-deep .v-input--error .v-label {
  color: var(--color-error) !important;
}

.theme-input::v-deep .v-messages {
  min-height: 16px;
  padding-top: 2px;
  margin-top: -1.5px;
}

.theme-input::v-deep .v-messages__message {
  color: var(--color-error) !important;
  font-size: 12px;
  line-height: 1;
  font-weight: 500;
}

/* Loading state */
.theme-input::v-deep .v-progress-linear {
  background-color: var(--color-secondary-light) !important;
}

.theme-input::v-deep .v-progress-linear__determinate {
  background-color: var(--color-secondary) !important;
}
</style>
